import {
  CookingTime,
  FirstOfferReplacementSettings,
  HighlightStories,
  ItemTagConnection,
  MarketableClassification,
  MarketableKind,
  Maybe,
} from '@lojinha/palantir'
import { CrumbProps } from '../../components/breadcrumb/types'

export type BannerComponent = {
  __typename: string
  url?: string | null
  description?: string | null
  title?: string | null
  crumbs?: CrumbProps[]
}

export type InsideProducts = {
  id: string
  name: string
  ingredients?: string | null
}

export type NutritionFact = {
  portionSize: string
  portionUnit: string
  facts: Array<{
    label: string
    value: number
    unit: string
    dailyValuePercentage: number
  }>
}

export enum PeriodName {
  Breakfast = 'BREAKFAST',
  Midmorning = 'MIDMORNING',
  Lunch = 'LUNCH',
  Midafternoon = 'MIDAFTERNOON',
  Dinner = 'DINNER',
  Supper = 'SUPPER',
  Other = 'OTHER',
}

export type Period = {
  name: string
  totalWeight: number
  totalPrice: number
  totalKcal: number
  products: Array<{
    id: string
    imageUrl: string
    name: string
    price?: number
    sku: string
    seo: {
      url: string
    }
  }>
}

export type InsideDays = {
  dayNumber: number
  totalKcal: number
  periods: Period[]
}

export type DisplayItems = {
  id: string
  imageUrl: string
  name: string
  kind: string
  classification: MarketableClassification
  sku: string
  ingredients?: string | null
  allergenics?: string | null
  price?: number | null
  priceFrom?: number | null
  totalMealsCount?: number | null
  unit?: string | null
  sellingStatus: string
  seo: {
    url: string
  }
  isAvailable: boolean
  isAgeRestricted?: boolean
  itemTags: ItemTagConnection
  weight?: number | null
  mainProduct?: string
  sideProducts?: string[]
  subtitle?: string
  products?: InsideProducts[]
  pricePerDay?: number
  pricePerMeal?: number
  meanPricePerDay?: number
  description?: string
  nutritionFacts?: NutritionFact | null
  days?: InsideDays[]
  cookingTimeMicrowave?: CookingTime | null
  cookingTimeOven?: CookingTime | null
  cookingTimeWaterBath?: CookingTime | null
  firstOfferReplacement?: Maybe<FirstOfferReplacementSettings>
}

export type DisplayComponent = {
  __typename: string
  id: string
  name: string
  isSubcategory?: boolean | null
  isHome?: boolean | null
  slug?: string
  kind: MarketableKind
  itemsOptimized: DisplayItems[]
  isFirstDisplay?: boolean
}

export type PageComponent =
  | BannerComponent
  | DisplayComponent
  | HighlightStories

export type Page = {
  title: string
  description: string
  seo: {
    title: string
    description: string
  }
  components: {
    totalCount: number
    nodes: PageComponent[]
  }
}

export type PageContentProps = {
  loading: boolean
  fullPath: string
  showEmptyState: boolean
  page?: Page | null
  onClickWillDeliver: () => void
  address?: string
  isHome: boolean
}
